import { Dot } from 'lucide-react';

const NotificationDot = ({ position }) => {
  return (
    <div className={`absolute ${position}`}>
      <Dot className="text-destructive" size={55} />
    </div>
  );
};

export default NotificationDot;
